import ButtonCheck from './ButtonCheck';
import ButtonCircle from './ButtonCircle';
import ButtonControl from './ButtonControl';
import ButtonDefault from './ButtonDefault';



export default {
  Control: ButtonControl,
  Check: ButtonCheck,
  Circle: ButtonCircle,
  Default: ButtonDefault,
};
